import { ArrowRight } from 'lucide-react';
import { Button, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from 'twyne-new.ui';

import InfoTip from 'components/InfoTip';

function BulkDropdown({ onClick: onClickProp, options, headerTitle, name, infoTip, ...rest }) {
  return <DropdownMenu>
    <DropdownMenuTrigger {...rest}>
      <Button variant='ghost' color='accent'>
        <div className='flex items-center gap-2'>
          {headerTitle.label && headerTitle.label}
          {headerTitle.label && <ArrowRight size={16} />}
          {headerTitle.prop}
          <InfoTip triggerProps={{ asChild: true }}>
            {infoTip}
          </InfoTip>
        </div>
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent>
      {options.map((option, idx) => <DropdownMenuItem key={idx} onClick={() => onClickProp({ prop: name, ...option })}>
        {option.label}
      </DropdownMenuItem>)}
    </DropdownMenuContent>
  </DropdownMenu>
}

export default BulkDropdown;
